<template>
  <div
    class="flex min-h-screen flex-col text-primary antialiased anchor-scrolling-none"
  >
    <div class="border-gray-200 border-b">
      <div
        class="mx-4 flex h-[4.375rem] items-center justify-center gap-1 md:container sm:gap-4"
      >
        <Logo class="ml-4 flex-initial" :width="138" :height="32" />
      </div>
    </div>
    <div class="mt-4 grow">
      <ErrorLayout :error="error" />
    </div>
  </div>
</template>

<script setup lang="ts">
const error = useError()

console.log('error', error)
console.error('error', error)

const { toLocalePath } = useRouteHelpers()

onBeforeUnmount(() => {
  reloadNuxtApp({
    path: toLocalePath(routeList.home).toString(),
  })
})

defineOptions({ name: 'GlobalError' })
</script>
